import { ChipStatus } from '../../componentes/ChipStatus.js';
import { DESCRICAO_DAS_FAMILIAS, rotuloDaFamilia, tomDaFamilia } from './familia.js';
import './LegendaDasFamilias.css';

/**
 * O que cada família quer dizer, escrito na própria tela.
 *
 * Sem a legenda, o chip vira decoração: quem chega no painel não tem como
 * saber que "entre depósitos" significa que a linha ainda vai virar lançamento no ERP,
 * nem que "origem indeterminada" é trabalho parado esperando alguém.
 */
export function LegendaDasFamilias() {
  return (
    <ul className="legenda-familias">
      {DESCRICAO_DAS_FAMILIAS.map(({ familia, texto }) => (
        <li key={familia} className="legenda-familias__item">
          <ChipStatus
            tom={tomDaFamilia(familia)}
            rotulo={rotuloDaFamilia(familia)}
            tamanho="tabela"
          />
          <span className="legenda-familias__texto">{texto}</span>
        </li>
      ))}
    </ul>
  );
}
